import * as React from "react";
import * as ReactDOM from "react-dom";

export interface ProgressRingControlProps extends React.Props<ProgressRingControl> {
    onMounted?: (div: HTMLDivElement) => void;
    onUnmount?: (div: HTMLDivElement) => void;
    className?: string;
}
    
export class ProgressRingControl extends React.Component<ProgressRingControlProps, any> {
    private div: HTMLDivElement;

    constructor(props: ProgressRingControlProps) {
        super(props);
    }

    public componentDidMount() {
        if (this.props.onMounted) {
            this.props.onMounted(this.div);
        }
    }

    public componentWillUnmount() {
        if (this.props.onUnmount) {
            this.props.onUnmount(this.div);
        }
    }

    public render() : JSX.Element {
        return (
            <div className={`progress-ring ${this.props.className ||''}`} ref={x => this.div = x}>
                <div className="progress-circle"></div>
                <div className="progress-circle"></div>
                <div className="progress-circle"></div>
                <div className="progress-circle"></div>
                <div className="progress-circle"></div>
            </div>); 
    }
}  



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/ProgressRingControl.tsx